import React from 'react';

const Spinner = ({ size = 'md', color = '#ff5a1f', className = '' }) => {
  const sizes = {
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48
  };

  const dimension = sizes[size] || sizes.md;

  return (
    <svg
      style={{ animation: 'spin 1s linear infinite' }}
      width={dimension}
      height={dimension}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <circle
        style={{ opacity: 0.25 }}
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="4"
      />
      <path
        style={{ opacity: 0.75 }}
        fill={color}
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export const LoadingOverlay = ({ message = 'Loading...' }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(11, 11, 14, 0.8)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      zIndex: 9999
    }}>
      <Spinner size="xl" />
      <p style={{ color: '#e5e7eb', fontSize: '16px' }}>{message}</p>
    </div>
  );
};

export default Spinner;
